define('payment/templates/withdraw-renderer',['jquery', 'boxes/helpers/payment-renderer-helper', 'boxes/helpers/formValidation', 'boxes/helpers/message-popup', 'boxes/helpers/box-loading',
		'payment/depositAmounts', 'payment/handlers/formTemplateHandlers/formTemplateHandlers',
		'payment/handlers/kyc-validator', 'payment/handlers/paymentMethodHandlers/paymentMethodHandlers',
		'boxes/events/feeEvent', 'all/pretty-links',
		'all/jquery/jquery.mustache'],
	function ($, paymentRendererHelper, formValidation, messagePopup, boxLoading, depositAmounts, formTemplateHandlers,
			  kycValidator, paymentMethodHandlers, feeEvent, prettyLinks) {
		'use strict';

		function getLastUsedAccountIdx(formTemplateData) {
			var lastUsedAccountIdx = 0;
			if (formTemplateData.lastUsedAccountIdx !== undefined) {
				lastUsedAccountIdx = formTemplateData.lastUsedAccountIdx;
			}
			return lastUsedAccountIdx;
		}

		function clearPreviousSelections(withdrawBox) {
			withdrawBox.$box.find('.amount-box').find('input').val('');
		}

		function extendTemplateDataForSummary(formTemplateData) {

			var lastUsedAccountIdx = getLastUsedAccountIdx(formTemplateData);

			var showEditButton;
			if (formTemplateData.editable !== undefined) {
				showEditButton = (formTemplateData.accounts.length > 0);
			} else {
				showEditButton = (formTemplateData.accounts.length > 1);
			}

			var extendedFormTemplateData = {
				account: formTemplateData.accounts[lastUsedAccountIdx],
				showEditButton: showEditButton
			};
			if(extendedFormTemplateData.account === undefined){
				extendedFormTemplateData.account = {};
			}
			$.extend(extendedFormTemplateData, formTemplateData);

			return extendedFormTemplateData;
		}

		function setupPendingKYCStatusBar(withdrawBox, formTemplate) {
			var methodId = withdrawBox.model.paymentController.selectedFormMethodId;
			var $statusBar = withdrawBox.$box.find('.pending-documents');
			kycValidator.init(withdrawBox);
			$.when(kycValidator.hasPendingDocuments(methodId, formTemplate)).done(function (dataResult) {
				if (dataResult.hasPendingApprovalDocuments === true) {
					$statusBar.off('click').on('click', function (e) {
						e.preventDefault();
						//Last minute request from business as always...
						window.location.href = prettyLinks.getLink('MyPages', 'SENDDOCUMENTS');
					});
					$statusBar.show();
				} else if (dataResult.hasPendingApprovalDocuments === 'Error') {
					$statusBar.off('click');
					$statusBar.hide();
					showPendingFailMessage(withdrawBox, {message: dataResult.errorCause});
				} else {
					$statusBar.off('click');
					$statusBar.hide();
				}
			});
		}

		function showPendingFailMessage(withdrawBox, failMessage) {
			messagePopup.show(withdrawBox.$box, 'message-popup', failMessage);
		}

		function showEditFormAndHideSummaryForm($paymentMethodForm) {
			// Hide summary part and show the edit part
			$paymentMethodForm.find('.summary').hide();
			$paymentMethodForm.find('.editform').show();
			$paymentMethodForm.find('.form-group.row').show();
		}

		function setupPaymentsEditButton(formTemplate, $paymentMethodForm, withdrawBox) {
			var formTemplateData = formTemplate.formTemplateData;

			// Hide the select account button as default
			$paymentMethodForm.find('.form-group.row').find('.stored').hide();

			if(typeof(formTemplateData.hasAccounts) !== 'undefined' && formTemplateData.hasAccounts === false){
				// I think only bankwire will fullfill this. Bankwire can be opened even if no deposit have been made, so there is no accounts
				// We have to start show the "editable form".
				showEditFormAndHideSummaryForm($paymentMethodForm);
				// This is for doing a reinit of the bankwWireWithdrawTemplateHandler
				formTemplateHandlers.setupFormTemplate($paymentMethodForm, formTemplate.paymentMethod.formTemplateCode, formTemplateData, withdrawBox);
			}

			$paymentMethodForm.find('.edit-button').off('click').on('click', function () {
				// Setup the click handler for the edit button

				$paymentMethodForm.find('#payments-edit-button').hide();

				if (formTemplateData.editable !== undefined) {
					showEditFormAndHideSummaryForm($paymentMethodForm);
				}
				// Show the account selection
				$paymentMethodForm.find('.form-group.row').find('select').show();

				var $stored = $paymentMethodForm.find('.stored');
				$stored.trigger('change');
			});

		}

		function render(formTemplate, withdrawBox) {
			var $paymentMethodForm = withdrawBox.$box.find(formTemplate.getSelectorClass());

			var paymentMethod = formTemplate.paymentMethod;

			paymentRendererHelper.reInitializeAmountAndFeeBoxes(withdrawBox);

			paymentRendererHelper.addValidations(formTemplate, withdrawBox);
			if (formTemplate.formTemplateData !== undefined) {
				var formTemplateData = formTemplate.formTemplateData;

				var extendedFormTemplateData = extendTemplateDataForSummary(formTemplateData);
				paymentRendererHelper.setupMustacheTemplate($paymentMethodForm, formTemplate.getMustacheClass(), extendedFormTemplateData);
				// formTemplateHandlers.setupFormTemplate will call bankwWireWithdrawTemplateHandler that will reset form to empty state
				// If there is an account then that reset should happen before triggerAccountSelectionEvent() otherwise form is empty state
				// If there is no bankwire account, then that reset thing have to happen again it seems like, it happens in setupPaymentsEditButton
				formTemplateHandlers.setupFormTemplate($paymentMethodForm, paymentMethod.formTemplateCode, formTemplateData, withdrawBox);
				paymentRendererHelper.setupAccountSelectionHandler(withdrawBox.$box, paymentMethod.formTemplateCode, formTemplate, withdrawBox);
				paymentRendererHelper.triggerAccountSelectionEvent(withdrawBox.$box, paymentMethod.formTemplateCode);
				setupPaymentsEditButton(formTemplate, $paymentMethodForm);
				setupPendingKYCStatusBar(withdrawBox, formTemplate);
			}

			paymentMethodHandlers.setupWithdrawFormTemplate(paymentMethod.methodName, withdrawBox);

			// TODO: possibly not show edit buttons if (formTemplate.initialised && formTemplate.formTemplateData.accounts.length > 0)?

			var controller = withdrawBox.model.paymentController;
			var selectedFormTemplate = controller.getSelectedFormTemplate();
			feeEvent.resetFee(withdrawBox, selectedFormTemplate.paymentMethod.methodId);
			$paymentMethodForm.show();

			// TODO: Possibly clear amount here calling clearPreviousSelections?

		}

		var withdrawRenderer = {};
		withdrawRenderer.render = render;
		return withdrawRenderer;
	});

